import React from 'react';
import BentoCard from '../layout/BentoCard';
import GradientText from '../ui/GradientText';
import Button from '../ui/Button';
import { profile } from '../../data/profile';

/**
 * CTASection - Call to Action section
 * Encourages visitors to get in touch
 */
const CTASection = () => {
  const socialLinks = [
    { name: 'GitHub', url: profile.github || '#' },
    { name: 'LinkedIn', url: profile.linkedin || '#' },
    { name: 'Email', url: `mailto:${profile.email}` || '#' }
  ];

  return (
    <BentoCard span="full" delay={500}>
      <div
        className="p-8 md:p-12 text-center relative overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, var(--color-bg-card) 0%, rgba(0, 180, 216, 0.08) 50%, rgba(0, 212, 170, 0.08) 100%)'
        }}
      >
        {/* Background Orbs */}
        <div className="absolute inset-0 opacity-30">
          <div
            className="absolute top-1/2 left-1/4 w-32 h-32 rounded-full blur-3xl"
            style={{ background: 'var(--color-accent)' }}
          />
          <div
            className="absolute top-1/2 right-1/4 w-32 h-32 rounded-full blur-3xl"
            style={{ background: 'var(--color-accent-alt)' }}
          />
        </div>

        {/* Content */}
        <div className="relative">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Ready to build something{' '}
            <GradientText>exceptional</GradientText>?
          </h2>

          <p
            className="text-lg mb-8 max-w-2xl mx-auto"
            style={{ color: 'var(--color-text-muted)' }}
          >
            Whether you need a full-stack solution, DevOps expertise, or system optimization,
            I'm here to help turn your vision into reality.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              variant="primary"
              size="lg"
              onClick={() => window.location.href = `mailto:${profile.email}?subject=Let's work together`}
            >
              Start a Conversation
            </Button>
            <Button
              variant="secondary"
              size="lg"
              href={profile.github}
              onClick={(e) => {
                e.preventDefault();
                window.open(profile.github, '_blank', 'noopener,noreferrer');
              }}
            >
              View GitHub
            </Button>
          </div>

          {/* Social Links */}
          <div className="flex justify-center gap-8 mt-8">
            {socialLinks.map((link, i) => (
              <a
                key={i}
                href={link.url}
                target={link.name !== 'Email' ? '_blank' : undefined}
                rel={link.name !== 'Email' ? 'noopener noreferrer' : undefined}
                className="text-sm font-medium transition-colors duration-300 hover:text-[var(--color-accent)]"
                style={{ color: 'var(--color-text-muted)' }}
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </BentoCard>
  );
};

export default CTASection;
